import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ajaxUser from "../../util/remote/ajaxUser";
import ajaxRole from "../../util/remote/ajaxRole";
const RegisterUserPage = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [role_id, setRoleId] = useState(null);
  const [deptID, setDeptID] = useState(null);
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // YYYY-MM-DD
  });
  // Roles
  const [Roles, setRoles] = useState([]);
  const fetchRolesList = async () => {
    const server_response = await ajaxRole.fetchRoleList({});
    if (server_response.status === "OK") {
      setRoles(server_response.details);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchRolesList();
  }, []);
  // Validation: all required fields
  const allRowsFilled = () =>
    firstName &&
    lastName &&
    username &&
    password &&
    email &&
    contact &&
    role_id;
  // Submit handler
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      first_name: firstName,
      last_name: lastName,
      username,
      password,
      email,
      contact,
      role_id: role_id.value,
      DeptID: deptID ? deptID.value : null, // ✅ optional
      date_created: dateCreated,
      created_by: userId,
    };
    setLoading(true);
    const response = await ajaxUser.createUser(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setUsername("");
    setPassword("");
    setEmail("");
    setContact("");
    setRoleId(null);
    setDeptID(null);
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  return (
    <AppContainer title="Register User">
      <div className="container-fluid">
        <Toaster />

        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register User</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* First Name */}
                    <div className="col-md-6">
                      <label>
                        First Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Last Name */}
                    <div className="col-md-6">
                      <label>
                        Last Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Username */}
                    <div className="col-md-6 mt-3">
                      <label>
                        Username <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Password */}
                    <div className="col-md-6 mt-3">
                      <label>
                        Password <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Email */}
                    <div className="col-md-6 mt-3">
                      <label>
                        Email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Contact */}
                    <div className="col-md-6 mt-3">
                      <label>
                        Contact <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Role */}
                    <div className="col-md-6 mt-3">
                      <label>
                        User Role <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        onChange={setRoleId}
                        options={Roles.map((r) => ({
                          value: r.role_id,
                          label: r.role_name,
                        }))}
                        value={role_id}
                        placeholder="Select Role"
                        isSearchable
                      />
                    </div>

                    {/* Date Created */}
                    <div className="col-md-6 mt-3">
                      <label>
                        Date Created <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        value={dateCreated}
                        onChange={(e) => setDateCreated(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  {/* Submit Button */}
                  <div className="d-flex justify-content-center col-lg-12 mt-3">
                    <button
                      type="submit"
                      className="btn btn-success col-lg-12"
                      disabled={!allRowsFilled() || loading}
                    >
                      {loading ? <Loader /> : "Register User"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default RegisterUserPage;
